<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4>Datos de contacto</h4>
                <p class="text-muted">Si cuentas con un consultorio o clínica, estos datos aparecerán automáticamente en los
                    documentos que expidas en el sistema.</p>
                <div v-if="contacts.length > 0">
                    <ul class="list-group">
                        <li v-for="contact in contacts" :key="contact.id" class="list-group-item">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="fw-light" v-if="contact.telefono_contacto"><strong>Teléfono:</strong> {{
                                        contact.telefono_contacto }}</span>
                                    <span class="fw-light" v-if="contact.email_contacto"><strong>Email:</strong> {{
                                        contact.email_contacto }}</span>
                                    <span class="fw-light" v-if="contact.domicilio_contacto"><strong>Domicilio:</strong> {{
                                        contact.domicilio_contacto }}</span>
                                </div>
                                <div class="text-end">
                                    <a href="#" class="text-center smallText me-2"
                                        @click="editContact(contact)">✏️Editar</a>
                                    <!-- <a href="#" class="text-center smallText"
                                        @click="deleteContact(contact.id)">🗑️Eliminar</a> -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="form-group">
                    <label for="tipoContacto">Tipo de Contacto</label>
                    <select id="tipoContacto" v-model="newContact.tipo_contacto" class="form-control"
                        @change="handleTipoContactoChange" required>
                        <option value="" disabled>Selecciona un tipo</option>
                        <option value="email">Email</option>
                        <option value="telefono">Teléfono</option>
                        <option value="domicilio">Domicilio</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="telefonoContacto">Teléfono</label>
                    <input type="text" id="telefonoContacto" v-mask="'###-###-####'" v-model="newContact.telefono_contacto"
                        class="form-control" :disabled="newContact.tipo_contacto !== 'telefono'"
                        placeholder="Ejemplo: 555-123-4567" />
                </div>
                <div class="form-group">
                    <label for="emailContacto">Email</label>
                    <input type="email" id="emailContacto" v-model="newContact.email_contacto" class="form-control"
                        :disabled="newContact.tipo_contacto !== 'email'" placeholder="Ejemplo: contacto@correo.com" />
                </div>
                <div class="form-group">
                    <label for="domicilioContacto">Domicilio</label>
                    <textarea id="domicilioContacto" v-model="newContact.domicilio_contacto" class="form-control"
                        :disabled="newContact.tipo_contacto !== 'domicilio'"
                        placeholder="Ejemplo: Calle 123, Ciudad"></textarea>
                </div>
                <vs-button @click="createContact" color="rgb(59,222,200)" gradient block>
                    {{ editingContactId ? "✏️ Actualizar Contacto" : "💾 Guardar Contacto" }}
                </vs-button>
                <p class="smallText fw-bold mt-3">Recuerda que debes tener los 3 tipos de contacto para cumplir con la norma ofical.</p>
                <hr />
                <div class="col-md-12 text-center">
                    <a class="smallText" @click="resetForm" href="#">Limpiar formulario</a>
                </div>

            </div>
        </div>

        <vs-dialog v-model="showDeleteDialog" title="Confirmar Eliminación" class="custom-dialog">
            <div class="container">
                <div class="row mb-3 mt-3">
                    <div class="col-md-12 text-center">
                        <span class="material-icons md-48 text-danger">warning</span>
                        <h4>Eliminar Contacto</h4>
                        <p>¿Estás seguro que deseas eliminar el contacto <strong>{{ contactToDelete?.telefono_contacto || contactToDelete?.email_contacto || contactToDelete?.domicilio_contacto }}</strong>?</p>
                        <div class="d-flex justify-content-center gap-3">
                            <vs-button @click="confirmDeleteContact" color="rgb(59,222,200)" gradient>
                                Sí, deseo continuar
                            </vs-button>
                            <vs-button @click="showDeleteDialog = false" color="rgb(255,77,77)" gradient>
                                Cancelar
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>
    </div>
  
</template>

<script>
    import axios from "axios";
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "PersonalMedicoContacto",
        props: {
            personal_medico_id: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                contacts: [],
                newContact: {
                    tipo_contacto: "",
                    telefono_contacto: "",
                    email_contacto: "",
                    domicilio_contacto: "",
                },
                editingContactId: null, // Track the contact being edited
                showDeleteDialog: false, // Controls the visibility of the delete confirmation dialog
                contactToDelete: null, // Stores the contact to be deleted
            };
        },
        mounted() {
            this.fetchContacts();
        },
        methods: {
            async fetchContacts() {
                try {
                    const response = await axios.get(`${API}/listar_contactos`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    if (response.data.status === "success") {
                        this.contacts = response.data.data;
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al listar contactos:", error);
                    this.notify("error", "Error al listar los contactos.");
                }
            },
            handleTipoContactoChange() {
                // Clear all related fields when tipo_contacto changes
                this.newContact.telefono_contacto = "";
                this.newContact.email_contacto = "";
                this.newContact.domicilio_contacto = "";
            },
            editContact(contact) {
                // Populate the form with the selected contact's data
                this.editingContactId = contact.id;
                this.newContact.tipo_contacto = contact.tipo_contacto;
                this.newContact.telefono_contacto = contact.telefono_contacto || "";
                this.newContact.email_contacto = contact.email_contacto || "";
                this.newContact.domicilio_contacto = contact.domicilio_contacto || "";
            },
            async createContact() {
                // Validate only the selected field and set others to null
                if (this.newContact.tipo_contacto === "telefono") {
                    if (!this.editingContactId && this.contacts.some(contact => contact.telefono_contacto)) {
                        this.notify("error", "Ya existe un teléfono registrado. Solo puedes tener uno.");
                        return;
                    }
                    if (!this.vPhoneMask(this.newContact.telefono_contacto, "Teléfono")) {
                        this.notify("error", "El campo Teléfono no cumple con el formato requerido.");
                        return;
                    }
                    this.newContact.email_contacto = null;
                    this.newContact.domicilio_contacto = null;
                } else if (this.newContact.tipo_contacto === "email") {
                    if (!this.editingContactId && this.contacts.some(contact => contact.email_contacto)) {
                        this.notify("error", "Ya existe un email registrado. Solo puedes tener uno.");
                        return;
                    }
                    if (!this.vEmail(this.newContact.email_contacto)) {
                        this.notify("error", "El campo Email no es válido.");
                        return;
                    }
                    this.newContact.telefono_contacto = null;
                    this.newContact.domicilio_contacto = null;
                } else if (this.newContact.tipo_contacto === "domicilio") {
                    if (!this.editingContactId && this.contacts.some(contact => contact.domicilio_contacto)) {
                        this.notify("error", "Ya existe un domicilio registrado. Solo puedes tener uno.");
                        return;
                    }
                    if (!this.vEmpty(this.newContact.domicilio_contacto, "Domicilio")) {
                        this.notify("error", "El campo Domicilio no puede estar vacío.");
                        return;
                    }
                    this.newContact.telefono_contacto = null;
                    this.newContact.email_contacto = null;
                } else {
                    this.notify("error", "Por favor selecciona un tipo de contacto válido.");
                    return;
                }

                try {
                    const payload = {
                        personal_medico_id: this.personal_medico_id,
                        ...this.newContact,
                    };

                    let response;
                    if (this.editingContactId) {
                        // Update existing contact
                        response = await axios.put(`${API}/actualizar_contacto/${this.editingContactId}`, payload);
                    } else {
                        // Create new contact
                        response = await axios.post(`${API}/crear_contacto`, payload);
                    }

                    if (response.data.status === "success") {
                        this.notify("success", this.editingContactId ? "Contacto actualizado exitosamente." : "Contacto creado exitosamente.");

                        await this.callAudit(this.personal_medico_id, this.editingContactId ? "ACTUALIZAR" : "CREAR", "personal_medico_contacto", this.personal_medico_id, this.editingContactId ? "Actualiza datos de contacto" : "Crea datos de contacto");
                        this.newContact = {
                            tipo_contacto: "",
                            telefono_contacto: "",
                            email_contacto: "",
                            domicilio_contacto: "",
                        };
                        this.editingContactId = null; // Reset editing state
                        this.fetchContacts();
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al guardar contacto:", error);
                    this.notify("error", "Error al guardar el contacto.");
                }
            },
            resetForm() {
                this.newContact = {
                    tipo_contacto: "",
                    telefono_contacto: "",
                    email_contacto: "",
                    domicilio_contacto: "",
                };
                this.editingContactId = null; // Reset editing state
            },
            deleteContact(contactId) {
                this.contactToDelete = this.contacts.find(contact => contact.id === contactId);
                this.showDeleteDialog = true;
            },
            async confirmDeleteContact() {
                if (!this.contactToDelete) return;

                try {
                    const response = await axios.delete(`${API}/eliminar_contacto/${this.contactToDelete.id}`);
                    if (response.data.status === "success") {
                        this.notify("success", "Contacto eliminado exitosamente.");
                        this.fetchContacts();
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al eliminar contacto:", error);
                    this.notify("error", "Error al eliminar el contacto.");
                } finally {
                    this.showDeleteDialog = false;
                    this.contactToDelete = null;
                }
            },
        },
    };
</script>

<style scoped>
    .list-group-item {
        margin-bottom: 10px;
    }
</style>